/* eslint-disable react-redux/useSelector-prefer-selectors */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { START } from 'pu-data/QuoteSteps';

import BundleItemTabWrap from 'pu-react/components/BundleItemTabWrap';
import Parameters from './Parameters';
import Prices from './Prices';
import Loading from './Loading';
import ParametersSummary from './ParametersSummary';

import { changeParameter as fabricationChangeParameter } from '../../pcb-fabrication/data/FabricationSlice'
import {
  fetchQuote,
  changeParameter,
  priceSelected,
  allowEdit,
  deleteQuote,
} from '../data/AssemblySlice'

const Subtitle = () => (
  <>
    To get an online PCB assembly quote simply
    fill out the following form and click on the GET A QUOTE button.
  </>
)

/**
 *
 * @param itemId id of bundle items, used when the projects is populate
 * @returns {JSX.Element}
 * @constructor
 */
const AssemblyTab = ({ itemId }) => {
  const dispatch = useDispatch();

  const {
    name,
    parameters,
    quote,
    suppliers,
    loading,
    showSummary,
    itemSelected,
    errors,
    quoteStep,
    firstQuoteMade,
    currentVariant,
  } = useSelector((state) => state.assembly);

  const fabricationQuote = useSelector((state) => state.fabrication).quote

  const onRequestQuote = () => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(fetchQuote(suppliers, parameters, authToken, itemId));
  }

  // eslint-disable-next-line no-shadow
  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
  }

  const onPriceSelect = (data) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(priceSelected(data, authToken, parameters.product_quote_number))
  }

  const showEdit = quoteStep !== START && showSummary
  const showDelete = quoteStep !== START && (!!quote || !!quote.line_items)

  useEffect(() => {
    if (Spree.home_assembly_parameters) {
      const authToken = document.getElementsByName('authenticity_token')[0].value;
      dispatch(fetchQuote(suppliers, parameters, authToken, itemId));
    }
  }, []);

  useEffect(() => {
    // Check if only the first quantity is provided
    const comesFromInstantQuote = parameters.quantities[0]
      && !parameters.quantities[1]
      && !parameters.quantities[2]
      && !parameters.quantities[3]
    const isFirstQuote = firstQuoteMade && parameters.product_quote_number === firstQuoteMade

    let quantities;
    if (comesFromInstantQuote && isFirstQuote) {
      quantities = quote.line_items[0].quantities
      onChangeParameter('quantities', quantities)
      onRequestQuote()
    } else if (isFirstQuote !== undefined) {
      quantities = parameters.quantities
    }

    // Sync quantities with pcb fabrication quote
    if (!fabricationQuote.number && quantities) {
      dispatch(fabricationChangeParameter({ name: 'qty1', value: quantities[0] }))
      dispatch(fabricationChangeParameter({ name: 'qty2', value: quantities[1] }))
      dispatch(fabricationChangeParameter({ name: 'qty3', value: quantities[2] }))
      dispatch(fabricationChangeParameter({ name: 'qty4', value: quantities[3] }))
    }
  }, [parameters.product_quote_number])

  return (
    <BundleItemTabWrap
      name={name}
      subtitle={<Subtitle />}
      showAnimationHeight={false}
      showEdit={showEdit}
      showDelete={showDelete}
      showSummary={showSummary}
      onEdit={() => dispatch(allowEdit())}
      onDelete={() => dispatch(deleteQuote())}
      contentClassName={{ summary: showSummary }}>
      <div className="pcb-assembly-section">
        <div className="pcb-assembly-form-section">
          <Loading loading={loading} />
          <div className="form-content">
            <div className="row">
              <div className="col-lg-5">
                <Parameters
                  itemId={itemId}
                  parameters={parameters}
                  itemSelected={itemSelected}
                  suppliers={suppliers}
                  onChangeParameter={onChangeParameter}
                  onRequestQuote={onRequestQuote}
                  showSummary={false}
                  errors={errors}
                  currentVariant={currentVariant} />
                <div className="summary-section">
                  <ParametersSummary showSummary={false} parameters={parameters} />
                </div>
              </div>
              <div className="col-lg-7">
                <Prices
                  itemId={itemId}
                  quote={quote}
                  quoteStep={quoteStep}
                  parameters={parameters}
                  showSummary={false}
                  parametersChanged={false}
                  onPriceSelect={onPriceSelect} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BundleItemTabWrap>
  );
};

AssemblyTab.propTypes = {
  itemId: PropTypes.number.isRequired,
}

export default AssemblyTab;
